import { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/Header.tsx';
import { AuthModal } from './components/AuthModal.tsx';
import { Home } from './pages/Home.tsx';
import { CategoryPage } from './pages/Category.tsx';
import { ArticlePage } from './pages/Article.tsx';
import { RoadmapPage } from './pages/Roadmap.tsx';
import { StatsPage } from './pages/Stats.tsx';
import { NotFound } from './pages/NotFound.tsx';
import { useApp } from './hooks/useApp.ts';
import { api } from './api.ts';

export default function App(): JSX.Element {
  const { state, refreshMe, setUser } = useApp();
  const [authOpen, setAuthOpen] = useState(false);

  const onSignOut = async (): Promise<void> => {
    await api.logout();
    setUser(null);
  };

  return (
    <>
      <ViewTracker />
      <Header
        state={state}
        onSignIn={() => setAuthOpen(true)}
        onSignOut={onSignOut}
      />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/a/:slug" element={<ArticlePage user={state.user} onRequestSignIn={() => setAuthOpen(true)} />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer className="site-footer">
        <div>
          © {new Date().getFullYear()} howtopython.com — built with Python in spirit, TypeScript in code.
        </div>
        <div>
          v{state.version} · {state.online} online · {state.visitors.weekly.toLocaleString()} this week · {state.visitors.total.toLocaleString()} all-time
        </div>
      </footer>

      {authOpen && (
        <AuthModal
          onClose={() => setAuthOpen(false)}
          onSuccess={(u) => { setUser(u); setAuthOpen(false); refreshMe(); }}
        />
      )}
    </>
  );
}

function ViewTracker(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    api.recordView(pathname);
  }, [pathname]);
  return null;
}
